module.exports = __webpack_public_path__ + "img/application-update-checked.9062aa7a.svg";